export default __webpack_public_path__ + "static/media/mc.5c5b19d1.svg";